/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Savings({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Savings_svg__a)"><path fill="currentColor" d="M10.8 8a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2" /><path fill="currentColor" d="M12.923 3.404a1 1 0 0 1 .863 1.496l-.864 1.512a.2.2 0 0 0 0 .2l.709 1.227a.2.2 0 0 0 .173.1h.396a1.2 1.2 0 0 1 1.2 1.2v1.6a1.2 1.2 0 0 1-1.2 1.2h-.853l-.04.003a.2.2 0 0 0-.102.055l-1.646 1.647a.2.2 0 0 0-.059.141v.703a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-.611c0-.144-.148-.24-.283-.191q-.272.099-.558.166a.206.206 0 0 0-.159.199v.437a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1.401a.2.2 0 0 0-.046-.128l-.033-.032A5 5 0 0 1 .5 8.988c0-1.394.571-2.656 1.492-3.563.255-.25.67-.121.844.19a.65.65 0 0 1-.1.764A3.8 3.8 0 0 0 1.7 8.989c0 1.213.57 2.295 1.46 2.992.33.259.54.661.54 1.106v1.201h1.6v-.237c0-.675.472-1.22 1.082-1.365l.214-.058q.105-.031.208-.07l.164-.048c.826-.191 1.732.398 1.732 1.367v.411h1.6v-.503c0-.371.147-.728.41-.99l1.646-1.647c.263-.262.62-.41.99-.41h.854v-1.6h-.396a1.4 1.4 0 0 1-1.212-.7l-.71-1.227a1.4 1.4 0 0 1-.002-1.395l.693-1.213a6 6 0 0 0-1.093.073c-.323.06-.75-.294-.712-.62.032-.268.202-.52.466-.574q.401-.083.819-.082z" /><circle cx={6} cy={3.2} r={2.2} stroke="currentColor" strokeWidth={1.2} /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M4.4 6.635A10.9 10.9 0 0 1 9.422 5" /></g><defs><clipPath id="Savings_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;